"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalExchange = void 0;
var react_1 = __importDefault(require("react"));
var ModalExchange_module_scss_1 = __importDefault(require("./ModalExchange.module.scss"));
var CardAuto_1 = require("../cardAuto/CardAuto");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var Svg_1 = require("../svg/Svg");
var FormExchange_1 = require("../formExchange/FormExchange");
var benefits = ['Гарантия 1 год', 'Скидка до 300 000', 'Первый взнос от 0%', 'Trade-in как первый взнос'];
var ModalExchange = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = react_1.default.useState(null), car = _b[0], setCar = _b[1];
    var _c = (0, react_redux_1.useSelector)(selectors_1.modalSelector), selectCar = _c.selectCar, exchange = _c.exchange;
    var modalExchangeState = exchange.modalState;
    var closeHandler = function () {
        dispatch((0, modalSlice_1.closeModal)('exchange'));
    };
    react_1.default.useEffect(function () {
        var carData = selectCar.filter.car.carSelect;
        if (carData && (!car || car.id !== carData.id)) {
            setCar(carData);
        }
    }, [selectCar, car]);
    if (!(car === null || car === void 0 ? void 0 : car.brand))
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "".concat(ModalExchange_module_scss_1.default.modal_exchange, " ").concat(modalExchangeState ? ModalExchange_module_scss_1.default.modal_exchange_active : ''), onClick: closeHandler },
        react_1.default.createElement("div", { className: ModalExchange_module_scss_1.default.modal_exchange__inner, onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement("header", { className: ModalExchange_module_scss_1.default.modal_exchange__header },
                react_1.default.createElement("h3", { className: ModalExchange_module_scss_1.default.modal_exchange__title }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 Trade in"),
                react_1.default.createElement("h4", null,
                    typeof car.brand === 'string' ? car.brand : car.brand.name,
                    " ", (_a = car.model) === null || _a === void 0 ? void 0 :
                    _a.name,
                    " ", car === null || car === void 0 ? void 0 :
                    car.year,
                    " \u0433."),
                react_1.default.createElement(Svg_1.Cross, { className: ModalExchange_module_scss_1.default.modal_exchange__cross, handler: closeHandler })),
            react_1.default.createElement("div", { className: ModalExchange_module_scss_1.default.modal_exchange__content },
                react_1.default.createElement("section", { className: ModalExchange_module_scss_1.default.modal_exchange__benefits }, benefits.map(function (benefit) {
                    return (react_1.default.createElement("article", { className: ModalExchange_module_scss_1.default.modal_exchange__benefits_item, key: benefit }, benefit));
                })),
                react_1.default.createElement("section", { className: ModalExchange_module_scss_1.default.modal_exchange__application },
                    react_1.default.createElement(FormExchange_1.FormExchange, null),
                    car.id ? (react_1.default.createElement(CardAuto_1.CardAuto, __assign({}, car, { extraClassName: ModalExchange_module_scss_1.default.modal_exchange__card_car, inModalCredit: true }))) : null)))));
};
exports.ModalExchange = ModalExchange;
